(function () {
  var mob = document.getElementById('arso-mob');
  if (mob) {
    var openBtn = document.getElementById('arso-open');
    var drawer = mob.querySelector('.arso-mob__drawer');
    var wasOpen = false;
    if (drawer) drawer.setAttribute('aria-modal', 'true');

    var sync = function () {
      var isOpen = mob.classList.contains('open');
      mob.inert = !isOpen;
      if (isOpen && !wasOpen) {
        var first = mob.querySelector('#arso-close, a, [role="button"]');
        if (first) first.focus({ preventScroll: true });
      } else if (!isOpen && wasOpen && openBtn) {
        openBtn.focus({ preventScroll: true });
      }
      wasOpen = isOpen;
    };

    mob.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !mob.classList.contains('open')) return;
      var f = mob.querySelectorAll('a[href], button, [role="button"]');
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    new MutationObserver(sync).observe(mob, { attributes: true, attributeFilter: ['class'] });
    sync();
  }

  document.querySelectorAll('.arso-cg-card[aria-label]').forEach(function (el) {
    el.removeAttribute('aria-label');
  });

  document.querySelectorAll('.arso-hero__btn-icon, .arso-ctaf__contact-icon').forEach(function (el) {
    el.setAttribute('aria-hidden', 'true');
  });

  document.querySelectorAll('.arso-cg-card__cantidad').forEach(function (el) {
    el.textContent = el.textContent.replace(/^(\s*)1 productos/, '$11 producto');
  });

  document.querySelectorAll('a[href^="tel:"]').forEach(function (a) {
    var digits = a.getAttribute('href').replace(/\D/g, '');
    if (digits.length === 10) a.setAttribute('href', 'tel:+52' + digits);
  });

  var producto = new URLSearchParams(location.search).get('producto');
  var contactBody = document.getElementById('ContactForm-body');
  if (producto && contactBody && !contactBody.value) {
    contactBody.value = 'Hola, quiero cotizar: ' + producto.slice(0, 150) + '\nCantidad: ';
  }
})();
